export default {"src":"/_next/static/media/autobandit_logo_white.862b4ec7.svg","height":22,"width":290,"blurWidth":0,"blurHeight":0};